// Mapping of route paths to module names for permission checking
export const ROUTE_MODULE_MAP: { [path: string]: { moduleName: string; requiredPermission?: string } } = {
  '/PotentialClients': { 
    moduleName: 'Clientes Potenciales', 
    requiredPermission: 'R' 
  },
  '/Admin': { 
    moduleName: 'Panel de Administración', 
    requiredPermission: 'R' 
  },
  '/ClientsManagement': { 
    moduleName: 'Administrar Clientes', 
    requiredPermission: 'R' 
  },
  '/Project': { 
    moduleName: 'Proyectos', 
    requiredPermission: 'R' 
  },
  '/BusinessThread': {
    moduleName: 'Proyectos',
    requiredPermission: 'R',
  },
  '/GlobalPlanning': {
    moduleName: 'Proyectos',
    requiredPermission: 'R',
  },
  '/GlobalPlanningV2': {
    moduleName: 'Proyectos',
    requiredPermission: 'R',
  },
  '/mobile/actions': {
    moduleName: 'Proyectos',
    requiredPermission: 'R',
  },
  '/mobile/actions/new': {
    moduleName: 'Proyectos',
    requiredPermission: 'C',
  },
  '/mobile/client/:id': {
    moduleName: 'Proyectos',
    requiredPermission: 'R',
  },
  '/SalesFunnelManagement': {
    moduleName: 'Proyectos',
    requiredPermission: 'R',
  },
  '/FinancialBudgetManager': { 
    moduleName: 'Presupuestos Financieros', 
    requiredPermission: 'R' 
  },
  '/Invoices': { 
    moduleName: 'Facturas', 
    requiredPermission: 'R' 
  },
  '/CreditNotes': {
    moduleName: 'Notas Crédito',
    requiredPermission: 'R'
  },
  '/OrderViewer': { 
    moduleName: 'Pedidos', 
    requiredPermission: 'R' 
  },
  '/CreatedOrders': {
    moduleName: 'Pedidos',
    requiredPermission: 'R'
  },
  '/Calendar': { 
    moduleName: 'Calendario', 
    requiredPermission: 'R' 
  },
  '/Gantt': { 
    moduleName: 'Diagrama de Gantt', 
    requiredPermission: 'R' 
  },
  '/user-config-demo': { 
    moduleName: 'Configuración de Usuario', 
    requiredPermission: 'R' 
  },
  '/responsive-demo': { 
    moduleName: 'Demo Responsivo'
  },
  '/StockQuery': {
    moduleName: 'Consulta',
    requiredPermission: 'R'
  },
  '/StickerCreator': {
    moduleName: 'Consulta',
    requiredPermission: 'R'
  },
};

const matchesRoutePattern = (pattern: string, path: string): boolean => {
  const patternParts = pattern.split('/').filter(Boolean);
  const pathParts = path.split('/').filter(Boolean);
  if (patternParts.length !== pathParts.length) return false;

  return patternParts.every((part, index) => part.startsWith(':') || part === pathParts[index]);
};

// Function to get module info for a given path
export const getModuleForPath = (path: string) => {
  if (ROUTE_MODULE_MAP[path]) return ROUTE_MODULE_MAP[path];

  const dynamicPath = Object.keys(ROUTE_MODULE_MAP).find((routePath) =>
    routePath.includes(':') && matchesRoutePattern(routePath, path),
  );
  return dynamicPath ? ROUTE_MODULE_MAP[dynamicPath] : null;
};

// Function to check if a path requires permission checking
export const pathRequiresPermission = (path: string): boolean => {
  return path !== '/login' && path !== '/' && Boolean(getModuleForPath(path));
};

export default ROUTE_MODULE_MAP;
